export const Section = ({ SectionItem }) => {
  return (
    <div className="py-5">
      <SectionItem />
    </div>
  );
};
